export const SET_CAMPAIGN_LOADER = "SET_CAMPAIGN_LOADER";
export const DELAY_COMMUNICATION_VIA_WHATSAPP = "DELAY_COMMUNICATION_VIA_WHATSAPP";
export const SUPPLIER_SUPPORT_VIA_WHATSAPP = "SUPPLIER_SUPPORT_VIA_WHATSAPP";